
<template>
  <div></div>
</template>

<script>
import { isWeixin, isIOS } from "../utils/index";
export default {
  components: {},
  data() {
    return {
      timer1: null,
    };
  },
  mounted() {
    this.iosInputBack();
  },
  methods: {
    /**
     * 字段判空
     */
    isEmpty(field) {
      return !field || field === "";
    },
    isEmptyObj(obj) {
      return Object.getOwnPropertyNames(obj).length === 0;
    },
    /**
     * 重置data
     */
    resetData() {
      const preData = this.$options.data.call(this);
      for (var i in preData) {
        this.$set(this, i, preData[i]); // 递归赋值
      }
    },
    iosInputBack() {
      if (isWeixin && isIOS) {
        this.timer1 = setInterval(() => {
          const inputArr = document.querySelectorAll("input");
          inputArr.forEach((item) => {
            if (!item.addMixinBlur) {
              item.addMixinBlur = true;
              item.addEventListener("blur", () => {
                const scrollTop =
                  document.documentElement.scrollTop || document.body.scrollTop;
                document.documentElement.scrollTop = document.body.scrollTop =
                  scrollTop;
                clearInterval(this.timer1);
                this.timer1 = null;
              });
            }
          });
        }, 300);
      }
    },
  },
};
</script>
<style lang="less">
</style>
